// E-Mail-Normalisierung fuer den Client.
// Deno-Pendant: supabase/functions/_shared/email.ts (Edge Functions koennen
// src/ nicht importieren, deshalb die bewusste Duplizierung).
//
// Hintergrund: profiles.email und adventure_bookings.email werden seit der
// Migration per DB-Trigger beim Schreiben auf lowercase normalisiert. Lookups
// muessen ihren Input deshalb ebenfalls normalisieren — sonst findet
// .eq("email", "M.Schleelein@web.de") die gespeicherte Kleinschreibung nicht.

/**
 * Trimmt und lowercased eine E-Mail-Adresse.
 * Gibt null zurueck fuer null/undefined/leer.
 */
export function normalizeEmail(input: string | null | undefined): string | null {
  if (typeof input !== "string") return null;
  const normalized = input.trim().toLowerCase();
  return normalized === "" ? null : normalized;
}

/** Case-insensitiver Vergleich zweier E-Mail-Adressen (In-Memory, ohne DB). */
export function emailsMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  const na = normalizeEmail(a);
  const nb = normalizeEmail(b);
  return na !== null && na === nb;
}
